import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Table, Tooltip, Card, Divider, Row, Col, Select, Empty } from 'antd';
import { createUseStyles } from 'react-jss'

import {
    PlusCircleOutlined,
    MinusCircleOutlined,
    ExclamationCircleOutlined,
    CloseCircleOutlined
} from '@ant-design/icons';

import { Action, POST, QueryDetail, QueryOrder, QueryParam, READWITH, errorCatch, updateInArray } from 'fennec-ui'
import Rule from '../../../common/Rule'
import { DropdownAction } from 'fennec-ui'
import ResheniePoVoprosuPovestkiDnyaZasedaniyaRegPravleniya from '../../forms/ResheniePoVoprosuPovestkiDnyaZasedaniyaRegPravleniya'
import ZakritieZasedaniyaRegionalnogoPravleniya from '../../forms/ZakritieZasedaniyaRegionalnogoPravleniya'
import PageLayout from '../../components/PageLayout';
import { useLocaladminContext } from '../../../common/Context';

const { Option } = Select;

const useStyles = createUseStyles({
    modal: {
        '& .ant-modal-title': {
            marginRight: "25px"
        }
    },
    divider: {
        '&.ant-divider-horizontal.ant-divider-with-text-left': {
            fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
            fontSize: "13px",
            fontWeight: "400",
            color: "rgb(0, 0, 0)",
        },
        '&.ant-divider-horizontal.ant-divider-with-text-left .ant-divider-inner-text': {
            padding: "0px",
            marginRight: "10px",
        }
    },
    block: {
        '& .buttons': {
            marginBottom: "10px"
        },
        // '& .buttons .ant-btn': {
        //     border: "none",
        //     '-webkit-box-shadow': "none",
        //     'box-shadow': "none"
        // }
    },
    actionTitle: {
        marginBottom: "5px"
    }
})

function Btn(props) {
    const { auth, setVoprosi } = props;
    const update = (values, unlock, close) => {
        var missing = props.object.zasedanieRegionalnogoPravleniya.kolichestvoPrisutstvuyushchikhChlenovPravleniya - (values.za + values.protiv + values.vozderzhalsya + values.neProgolosoval);
        var v = {
            ...values,
            neProgolosoval: values.neProgolosoval + missing
        }
        POST(auth, `/api/query-update/ResheniePoVoprosuPovestkiDnyaZasedaniyaRegPravleniya`, { ...props.object, ...v }, ({ data }) => {
            if (close) close();
            setVoprosi(o => updateInArray(o, data))
        }, errorCatch)

    };

    return (
        <DropdownAction items={[
            {
                ...props,
                modal: { width: "700px" },
                action: update,
                mode: "MenuItem",
                auth: props.auth,
                callback: props.callback,
                object: props.object,
                title: "Решение по вопросу",
                form: ResheniePoVoprosuPovestkiDnyaZasedaniyaRegPravleniya,
                document: "resheniepovoprosupovestkidnyazasedaniyaregpravleniya",
            }
        ]} />
    )
};
function GolosovanieRegiona(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const { auth, regionalnoeOtdelenie } = props;
    const [zasedanie, setZasedanie] = useState();
    const [voprosi, setVoprosi] = useState();

    useEffect(() => {
        READWITH(auth, "ZasedaniyaRegionalnogoPravleniya", [
            QueryDetail("model"),
            QueryParam("w-regionalnoeOtdelenie.ID", regionalnoeOtdelenie?.ID),
            QueryParam("w-in-tekushchiiStatusZasedaniya.ID", "3,4")
        ], ({ data }) => {
            if (data?.length) {
                setZasedanie(data[0]);
            }
        }, errorCatch)
    }, [regionalnoeOtdelenie]);

    useEffect(() => {
        if (zasedanie) {
            requestVoprosi(zasedanie);
        }
    }, [zasedanie]);

    useEffect(() => {
        requestVoprosi(zasedanie);
    }, [regionalnoeOtdelenie]);

    const requestVoprosi = (zasedanie) => {
        if (zasedanie) {
            READWITH(auth, "ResheniePoVoprosuPovestkiDnyaZasedaniyaRegPravleniya", [
                QueryDetail("model"),
                QueryParam("w-zasedanieRegionalnogoPravleniya.ID", zasedanie?.ID),
                QueryOrder("voprosPovestkiDnyaZasedaniyaRegPravleniya.nomerVoprosa", "ASC")
            ], ({ data }) => {
                setVoprosi(data);
            }, errorCatch)
        }
    };

    const columns = [
        {
            title: '№',
            render: (text, record, index) => {
                return (record.voprosPovestkiDnyaZasedaniyaRegPravleniya.nomerVoprosa);
            }
        },
        {
            title: 'Вопрос',
            render: (text, record, index) => {
                return (record.voprosPovestkiDnya);
            }
        },
        {
            title: 'Решение',
            render: (text, record, index) => {
                return (record.resheniePoVoprosuPovestkiDnya);
            }
        },
        {
            title: <Tooltip title="За"><PlusCircleOutlined style={{ color: "green" }} /></Tooltip>,
            render: (text, record, index) => {
                return (record.za);
            }
        },
        {
            title: <Tooltip title="Против"><MinusCircleOutlined style={{ color: "red" }} /></Tooltip>,
            render: (text, record, index) => {
                return (record.protiv);
            }
        },
        {
            title: <Tooltip title="Воздержался"><ExclamationCircleOutlined style={{ color: "orange" }} /></Tooltip>,
            render: (text, record, index) => {
                return (record.vozderzhalsya);
            }
        },
        {
            title: <Tooltip title="Не проголосовал"><CloseCircleOutlined style={{ color: "grey" }} /></Tooltip>,
            render: (text, record, index) => {
                return (record.neProgolosoval);
            }
        },
        // {
        //     title: 'Принято',
        //     render: (text, record, index) => {
        //         return (record.prinyatoReshenie);
        //     }
        // },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => (<Btn auth={auth} object={record} callback={(res) => {
                requestVoprosi(zasedanie);
            }} setVoprosi={setVoprosi} />),
        },
    ];
    const closeCallback = (res) => {
        setZasedanie(res.data.zasedanieRegionalnogoPravleniya);
        setVoprosi([]);
    };
    return (
        <div>
            <Divider className={classes.divider} type="horizontal" orientation="left">
                Голосование на текущем заседании правления федерации
            </Divider>
            <Table columns={columns} dataSource={voprosi} style={{ paddingBottom: "15px" }} locale={{ emptyText: <Empty description={"Нет вопросов повестки дня для голосования"}></Empty> }} size="small" rowKey={(r) => r.ID} />
            <Rule type={"zakritiezasedaniyaregionalnogopravleniya"}
                object={zasedanie}>
                <Action
                    auth={auth}
                    //  callback={closeCallback}
                    object={zasedanie}
                    title={"Закрытие заседания правления федерации"}
                    form={ZakritieZasedaniyaRegionalnogoPravleniya}
                    //  document={"zakritiezasedaniyaregionalnogopravleniya"}
                    action={(values, unlock, close) => {
                        POST(auth, `/api/zakritiezasedaniyaregionalnogopravleniya`, values,
                            (res) => {
                                closeCallback(res)
                                close()
                            }, (err) => errorCatch(err, unlock)
                        )
                    }}
                />
            </Rule>
        </div>
    );
}
export default function LocaladminGovernanceVotingcurrentmeeting(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const { status } = props;
    const { auth } = props;
    const local = useLocaladminContext();

    return (
        <PageLayout>
            <Row gutter={[5, 5]}>
                <Col span={24}>
                    <Card size="small" className={classes.block}>
                        {local && <GolosovanieRegiona {...props} regionalnoeOtdelenie={local}></GolosovanieRegiona>}
                    </Card>
                </Col>
            </Row>
        </PageLayout>
    );
}
